import React, { useEffect, useMemo, useState } from 'react';

import { calculateRowTotals } from '../../utils/calculations';
import { getIndentClass } from '../../utils/styleUtils';

import MilestoneTypeRow from './MilestoneTypeRow';
import SponsorMilestoneData from './SponsorMilestoneData';

import { formatFigure } from 'Helpers/formatService';

import ChevronDownIcon from 'Assets/icons/chevron-down.svg';
import ChevronUpIcon from 'Assets/icons/chevron-up.svg';

export default function ContractRow(props) {
    const [showContractChildren, setShowContractChildren] = useState(false);

    // Handle expand all trigger from parent with staggered updates
    useEffect(() => {
        const t = props.expandAllTrigger;
        if (!t?.version) return;

        if (t.batch === 'committed' || t.batch === 'projects committed') {
            setShowContractChildren(t.expanded);
        }
    }, [props.expandAllTrigger?.version]);

    // Calculate indentation level
    const indentLevel = props.indentLevel || 4;
    const childIndentLevel = indentLevel + 1;

    const toggleContractShow = () => {
        setShowContractChildren(!showContractChildren);
    };

    const { contract, maxSponsorMilestonesCount } = props;

    const contractTotals = useMemo(() => {
        return calculateRowTotals(contract.currentMilestones);
    }, [contract.currentMilestones]);

    return (
        <>
            <tr className="!tw-bg-gray-100">
                <td>
                    <div className={`tw-flex tw-items-center tw-gap-x-1.5 tw-cursor-pointer ${getIndentClass(indentLevel)}`} onClick={toggleContractShow}>
                        <div className="tw-font-medium tw-text-gray-600">{contract.contract_reference}</div>
                        <div>{showContractChildren ? <ChevronUpIcon /> : <ChevronDownIcon />}</div>
                    </div>
                </td>
                <td className="tw-p-4"></td>
                <td className="tw-p-4 tw-text-right tw-text-gray-600 tw-border-r-2">{formatFigure(contractTotals.totalValue)}</td>
                {contract.currentMilestones &&
                    [...Array(maxSponsorMilestonesCount)].map((e, i) => {
                        return (
                            <React.Fragment key={`contract_${contract.contract_reference}_milestones_${i}`}>
                                <SponsorMilestoneData
                                    key={`${props.keyPrefix || ''}contract_${contract.contract_reference}_milestone_${i}`}
                                    milestones={contract.currentMilestones}
                                    milestoneId={i}
                                    keyPrefix={props.keyPrefix || ''}
                                    amountOnly={true}
                                />
                            </React.Fragment>
                        );
                    })}
                <td className="tw-p-4 tw-text-right tw-border-r-2"></td>
                <td className="tw-p-4 tw-text-right tw-border-r-2">{formatFigure(contractTotals.totalValue)}</td>
                <td className="tw-p-4 tw-text-right tw-border-r-2"></td>
            </tr>
            {showContractChildren && (
                <>
                    <MilestoneTypeRow
                        {...props}
                        key={`contract_${contract.contract_reference}_cash_${props.sponsor.id}`}
                        type="cash"
                        label="Cash"
                        data={contract}
                        periods={props.periods}
                        indentLevel={childIndentLevel}
                        sponsor={props.sponsor}
                        contract={contract}
                        rowTotalValue={Math.max(0, contract.value - contract.vik)}
                    />
                    <MilestoneTypeRow
                        {...props}
                        key={`contract_${contract.contract_reference}_vik_${props.sponsor.id}`}
                        type="vik"
                        label="VIK"
                        data={contract}
                        periods={props.periods}
                        indentLevel={childIndentLevel}
                        sponsor={props.sponsor}
                        contract={contract}
                        rowTotalValue={contract.vik}
                    />
                </>
            )}
        </>
    );
}
